// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Report from "@material-ui/icons/Report";
import Reconciliation from "@material-ui/icons/RestorePage";
import Audit from "@material-ui/icons/TrackChanges";
import AirlineRouteIcon from "@material-ui/icons/Flight";
import WalletIcon from "@material-ui/core/SvgIcon/SvgIcon";
import Landing from "@material-ui/icons/FlightLandOutlined";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";
import Reports from "layouts/recordsLanding/regional-reports-landing.js";

import NotFound from "views/NotFound/Index.jsx";

import AirlinesPassengerPage from "Regional-Views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "Regional-Views/AirlinePayment/Index.jsx";
import SettlementPage from "Regional-Views/Settlement/Index.jsx";
import BillablePassengers from "Regional-Views/BillablePassengers/Index.jsx";
import PSCUtilization from "Regional-Views/PSCUtilization/Index.jsx";
import PDM from "Regional-Views/PDM/Index.jsx";
import TransitPassengerPage from "Regional-Views/Transit/Index.jsx";
import StatementOfAccount from "Regional-Views/StatementOfAccount/Index.jsx";
import OutstandingSettlementPage from "Regional-Views/OutstandingSettlement/Index.jsx";
import ExchangeRateAirlineView from "Regional-Views/ExchangeRateAirline/airlineView.js";
import WalletReport from "Regional-Views/WalletReport";
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"

const routes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/passenger-data",
    sidebarName: "Passenger Data",
    navbarName: "Airline Passenger Data",
    icon: Passenger,
    subMenu: [],
    component: AirlinesPassengerPage
  },
  {
    path: "/app/psc-regional/airline-payment",
    sidebarName: "Airline Payment",
    navbarName: "Airline Payment Report",
    icon: Flight,
    subMenu: [],
    component: AirlinePaymentPage
  },
  {
    path: "/app/psc-regional/psc-settlement",
    sidebarName: " PSC Settlement",
    navbarName: "PSC Settlement",
    icon: Settlement,
    subMenu: [],
    component: SettlementPage
  },
  {
    path: "/app/psc-regional/outstanding-settlement",
    sidebarName: "Outstanding Settlement",
    navbarName: "Outstanding Settlement",
    icon: Settlement,
    subMenu: [],
    component: OutstandingSettlementPage
  },
  {
    path: "/app/psc-regional/reports-landing",
    sidebarName: "PSC Reports",
    navbarName: "Psc Reports",
    icon: Report,
    component: Reports,
    subMenu: [],
    
  },
  {
    path: "/app/psc-regional/psc-utilization",
    sidebarName: "PSC Utilization",
    isNotVisible: true,
    navbarName: "PSC Utilization",
    icon: Dashboard,
    component: PSCUtilization,
    subMenu: [],
    
  },
  {
    path: "/app/psc-regional/billable-passengers",
    sidebarName: "Billable Passengers",
    isNotVisible: true,
    navbarName: "Total Passengers vs Billable Passengers",
    icon: BillablePassengers,
    component: BillablePassengers,
    subMenu: [],
    
  },
  {
    path: "/app/psc-regional/transit-passenger-report",
    sidebarName: "Transit Passenger",
    isNotVisible: true,
    navbarName: "Transit Passenger",
    icon: Report,
    component: TransitPassengerPage,
    subMenu: [],
    
  },
  {
    path: "/app/psc-regional/statement-of-account",
    sidebarName: "Account Statement",
    isNotVisible: true,
    navbarName: "Account Statement",
    icon: Reconciliation,
    component: StatementOfAccount,
    subMenu: []
  },
  {
    path: "/app/psc-regional/pdm",
    sidebarName: "PDM",
    navbarName: "PDM",
    icon: Reconciliation,
    component: PDM,
    subMenu: [],
    
  },
  {
    path: "/app/psc-regional/wallet-report",
    sidebarName: "Airline Wallet Report",
    isNotVisible: true,
    navbarName: "Airline Wallet Report",
    icon: WalletIcon,
    component: WalletReport,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/exchange-rate",
    sidebarName: "Exchange Rate",
    navbarName: "Exchange Rate",
    icon: AirlineRouteIcon,
    subMenu: [],
    component: ExchangeRateAirlineView,
  },
  {
    path: "/app/psc-regional/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,
    
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/regional-staff.jsx